<div class="" style="background-color: var(--main2);">
    <div class="row ft-mrg" >
        <div class="col-md-2 set-footer p-4" *ngIf="english">
            <a href="https://payg.in/contact.html?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" style="color:white ;" target="_blank">Need Help? Contact Us</a>
        </div>
        <div class="col-md-5 set-footer p-4" *ngIf="english">
            <a href="https://www.youtube.com/@paygindia" class="ft" target="_blank">Youtube Videos </a>
        </div>
        <div class="col-md-2 set-footer p-4" *ngIf="english">
            <a href="https://blog.payg.in/?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" target="_blank">Blogs</a>
        </div>
        <div class="col-md-3 set-footer p-4" *ngIf="english">
            <a href="https://payg.in/developer.html?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" target="_blank">Developer Documents</a>
        </div>
        <div class="col-md-3 set-footer p-4" *ngIf="english">
            <a href="https://payg.in/download-mobile-app.html?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" target="_blank">Download PayG App</a>
        </div>
        <div class="col-md-3 set-footer p-4" *ngIf="hindi">
            <a href="https://payg.in/contact.html?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" style="color:white;" target="_blank">मदद की ज़रूरत है? संपर्क करें</a>
        </div>
        <div class="col-md-2 set-footer p-4" *ngIf="hindi">
            <a href="https://www.youtube.com/@paygindia" class="ft" target="_blank" target="_blank">यूट्यूब वीडियो</a>
        </div>
        <div class="col-md-2 set-footer p-4" *ngIf="hindi">
            <a href="https://blog.payg.in/?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" target="_blank">ब्लॉग</a>
        </div>
        <div class="col-md-3 set-footer p-4" *ngIf="hindi">
            <a href="https://payg.in/developer.html?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" target="_blank">डेवलपर दस्तावेज़</a>
        </div>
        <div class="col-md-3 set-footer p-4" *ngIf="hindi">
            <a href="https://payg.in/download-mobile-app.html?utm_source=docs_section&utm_medium=organic&utm_campaign=Internal" class="ft" target="_blank">पे जी ऐप डाउनलोड करें</a>
        </div>
    </div>
</div>